import * as React from 'react';
import { Navigate } from 'react-router-dom';
import type { FeatureFlags } from '@tokenforge/shared';
import { useFeatureFlag } from '../feature-flags/useFeatureFlag';

interface Props {
  flag: keyof FeatureFlags;
  children: React.ReactNode;
}

export function PermissionGate({ flag, children }: Props) {
  const enabled = useFeatureFlag(flag);
  if (!enabled) return <Navigate to="/403" replace />;
  return <>{children}</>;
}
